module.exports = __webpack_public_path__ + "img/trash.a72ee5a8.svg";